import { render, staticRenderFns } from "./BaseServiceSaas.vue?vue&type=template&id=48778b7a&"
import script from "./BaseServiceSaas.vue?vue&type=script&lang=js&"
export * from "./BaseServiceSaas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports